export function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

// Handles both plain string arrays and API language objects [{id, name}]
export function formatLanguages(languages) {
  if (!languages || languages.length === 0) return "";
  return languages.map((l) => (typeof l === "string" ? l : l.name)).join(" | ");
}
